// A block the seller just inserted should take the caret; one restored from a
// saved value must not — CodeMirror's autoFocus scrolls the page to the block,
// dragging the form to a field nobody asked for.
//
// Its own module rather than an export from HtmlPlugin: the plugin marks keys and
// the decorator's editor consumes them, and those two already reach each other
// through HtmlNode, so sharing it either way round would close an import cycle.
const justInsertedNodeKeys = new Set();

export const markJustInserted = nodeKey => justInsertedNodeKeys.add(nodeKey);

// Consumes the key: a block is only ever "just inserted" for the mount that
// follows the insert.
export const takeJustInserted = nodeKey => justInsertedNodeKeys.delete(nodeKey);
